import { Button } from '../../../../../../components/button/button';
import { Container } from '../../../../../../components/container/container';
import { Loader } from '../../../../../../components/loader/loader';
import { ModalProps, Modal } from '../../../../../../components/modal/modal';
import { Timeline } from '../../../../../../components/timeline/timeline';
import { formatRuDateTimeString } from '../../../../../../helpers/date-time';
import { useLang } from '../../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { paymentMethodMap } from '../../../../../../store/api/branches-api';
import { useEmployeesStore } from '../../../../../../store/use-employee-store';
import { useTaskStore } from '../../../../../../store/use-task-store';
import { statusTitleMap } from '../../use-task-list';
import s from './tasks-info-modal.module.css';

export const TaskInfoModal = (props: ModalProps) => {
  const params = useQueryParams().getQueryParams();
  const id = params.taskId;
  const { list, isLoadingFetch } = useTaskStore();
  const { t, getLocale } = useLang();
  const { staff } = useEmployeesStore();

  const selectedTask = list?.find((task) => String(task.id) === id);

  const photo = selectedTask?.photo;
  const payment = selectedTask?.payment_method;
  const dishes = selectedTask?.additional_info.dishes;
  const cost = dishes?.reduce((acc, dish) => acc + dish.cost * dish.count, 0);
  const history = selectedTask?.status_history;
  history?.reverse();

  return (
    <Modal {...props} title={getLocale(selectedTask?.title)} className={s.feature}>
      {isLoadingFetch && <Loader />}
      <div className={s.content}>
        {!!history?.length && (
          <Timeline
            steps={history.map((item) => {
              const employee = staff?.find((employee) => employee.id === item.user_id);
              const employeeName = employee
                ? `${getLocale(employee.name)} ${getLocale(employee.surname)}`
                : '';
              return {
                id: item.status,
                date: formatRuDateTimeString(item.created_at),
                label: `${t(statusTitleMap[item.status])} ${employeeName}`,
              };
            })}
          />
        )}
        <div className={s.col}>
          {!!dishes?.length && (
            <Container label={t('Блюда')} className={s.container}>
              <ul className={s.dishes}>
                {dishes.map((dish, index) => (
                  <li key={getLocale(dish.name) + index}>
                    {`${getLocale(dish.name)} - ${dish.cost} * ${dish.count}${t('шт')}`}
                  </li>
                ))}
              </ul>
            </Container>
          )}
          {typeof cost === 'number' && (
            <Container label={t('Общая стоимость')} className={s.container}>
              {cost.toString()}
            </Container>
          )}
          {payment && (
            <Container label={t('Способ оплаты')} className={s.container}>
              {paymentMethodMap[payment]}
            </Container>
          )}
          {photo && (
            <Container label={t('Отчет исполнителя')} className={s.container}>
              <img src={photo} alt="Отчет исполнителя" className={s.img} />
            </Container>
          )}
        </div>
      </div>
      <div className={s.controls}>
        <Button variant="secondary" onClick={props.onClose}>
          {t('Назад')}
        </Button>
      </div>
    </Modal>
  );
};
